<template>
  <vonap-promised :promise="promise">
    <vonap-fullscreen-dialog
      :title="currentDivision.divisionName || 'New Division'"
      :show-close-button="true"
      :show-save-button="!isDisabled"
      @save="formSubmit"
      @close="show = false"
    >
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="formSubmit">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex lg3 md3 xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Division"
                    v-model="currentDivision.divisionName"
                    required
                    :rules="[v => !!v || 'Division name is required']"
                    :disabled="isDisabled"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Legal Name"
                    v-model="currentDivision.legalName"
                    required
                    :rules="[v => !!v || 'Legal name is required']"
                    :disabled="isDisabled"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    label="Sector"
                    v-model="currentDivision.sectorId"
                    item-value="sectorId"
                    item-text="sectorCode"
                    :items="sectorData"
                    :disabled="isDisabled"
                    required
                    :rules="[v => !!v || 'Sector is required']"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 mr-auto>
                  <v-select
                    label="Base Currency"
                    v-model="currentDivision.baseCcy"
                    item-value="ccy"
                    item-text="ccy"
                    :items="ccyData"
                    :disabled="isDisabled"
                    required
                    :rules="[v => !!v || 'Base Ccy is required']"
                  />
                </v-flex>
                <v-flex xs6>
                  <vonap-form-label
                    style="margin-top:9px;color:#787878"
                    label="Allowed Trade Entry"
                  >
                    <v-switch
                      v-model="currentDivision.allowedTradeEntry"
                      style="margin-top:0"
                    ></v-switch>
                  </vonap-form-label>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <visionap-switch-list
                    :data-source="currentDivision.usersList"
                    :value="usersData"
                    data-value-field="userId"
                    data-text-field="userName"
                    label-text="Users"
                    item-text="User"
                    item-icon="supervised_user_circle"
                    :number-of-items="2"
                    :show-select-all="true"
                    select-all-label="Select all users"
                    :show-search="false"
                    :is-disabled="isDisabled"
                    @input="currentDivision.usersList = $event"
                  ></visionap-switch-list>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex lg8 offset-lg1 md8 offset-md1 xs12>
              <v-layout row>
                <market-data-separator
                  v-for="market in marketData"
                  :key="market.marketId"
                  :market="market"
                  :data-source="productData"
                  :value="products"
                  v-slot="{dataSource: ds, marketValues, selectedValues}"
                  style="border:1px solid #f1f1f1;box-shadow:1px 2px 3px #dadada;margin:8px"
                >
                  <v-flex xs6 md5 lg4>
                    <vonap-form-label :label="market.marketCode + ' Market Product Selection'">
                      <vonap-switch-list
                        :use-v-card="false"
                        max-height="400px"
                        flex-size="xs6"
                        :data-source="ds"
                        :selected-toolbar-tools="['moveUp', 'moveDown']"
                        data-value-field="productId"
                        data-text-field="product"
                        :value="marketValues"
                        @input="currentDivision.products = products = selectedValues($event)"
                        width="130px"
                      />
                    </vonap-form-label>
                  </v-flex>
                </market-data-separator>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </vonap-fullscreen-dialog>
  </vonap-promised>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import VonapSwitchList from '@/components/VonapSwitchList'
import VonapFullscreenDialog from '@/components/VonapFullscreenDialog'
import VonapFormLabel from '@/components/VonapFormLabel'
import VonapPromised from '@/components/VonapPromised'
import VisionapSwitchList from '@/components/VisionapSwitchList'
import MarketDataSeparator from '@/views/Config/MarketDataSeparator'
import security from '@/mixins/security'

export default {
  name: 'Form',
  props: {
    value: Boolean,
    divisionId: Number,
  },
  mixins: [security],
  data() {
    return {
      isNew: this.divisionId == -1,
      saving: false,
      errored: false,
      valid: false,
      products: [],
      currentDivision: {
        divisionId: -1,
        divisionName: '',
        legalName: '',
        sectorId: 0,
        sectorCode: '',
        baseCcy: '',
        allowedTradeEntry: false,
        usersList: [],
        products: [],
        monthsAccountReceivable: 0,
      },
      sectorData: [],
      ccyData: [],
      usersData: [],
      marketData: [],
      productData: [],
    }
  },
  methods: {
    async formSubmit() {
      if (!this.$refs.form.validate()) return

      this.currentDivision.divisionId = +this.currentDivision.divisionId
      this.currentDivision.monthsAccountReceivable = +this.currentDivision.monthsAccountReceivable
      this.currentDivision.sectorId = +this.currentDivision.sectorId
      this.currentDivision.monthsAccountReceivable = +this.currentDivision.monthsAccountReceivable
      this.saving = true
      if (this.currentDivision.divisionId != -1) {
        await axios
          .put('/api/config/Division', {
            item: this.currentDivision,
            clientId: +this.clientId,
          })
          .catch(() => (this.errored = true))
        this.saving = false
      } else {
        const {data} = await axios
          .post('/api/config/Division', {
            item: this.currentDivision,
            clientId: +this.clientId,
          })
          .catch(() => (this.errored = true))
        const newDivision = data.data[0]
        this.isNew = false
        this.currentDivision.divisionId = newDivision.divisionId
        this.saving = false
      }

      this.$emit('save')
    },
    async getData() {
      if (this.divisionId != -1) {
        const {data: currentDivision} = await axios.get('/api/config/Division/getDivision', {
          params: {divisionId: this.divisionId},
        })
        this.currentDivision = currentDivision
      }

      const {data: sectorData} = await axios.get(
        '/api/config/division/getSectors?clientId=' + this.clientId,
        {},
      )
      this.sectorData = sectorData

      const {data: ccyData} = await axios.get(
        '/api/config/division/getCurrencies?clientId=' + this.clientId,
        {},
      )
      this.ccyData = ccyData

      const {data: usersData} = await axios.get(
        '/api/config/division/getUsers?clientId=' + this.clientId,
        {},
      )
      this.usersData = usersData

      const {data: marketData} = await axios.get(
        '/api/config/division/getMarketsByDivision?clientId=' + this.clientId,
        {},
      )
      this.marketData = marketData

      const {
        data: {availableProducts, assignedProducts},
      } = await axios.get(
        '/api/config/division/getProductsByDivision?divisionId=' +
          this.divisionId +
          '&clientId=' +
          this.clientId,
        {},
      )

      this.productData = availableProducts
      this.products = assignedProducts
      this.currentDivision.products = assignedProducts
    },
  },
  computed: {
    isDisabled() {
      return this.isReadOnly
    },
    marketsDataSourceInOrder() {
      return []
    },
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    promise() {
      return this.getData()
    },
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({currentRole: 'authentication/currentRole'}),
  },
  components: {
    VonapFullscreenDialog,
    VonapFormLabel,
    VonapPromised,
    VonapSwitchList,
    VisionapSwitchList,
    MarketDataSeparator,
  },
}
</script>
